
const MemberTypeItemNames = [
    '',
    '申込（正会員）',
    '仮入会（正会員）',
    '正会員',
    '申込（准会員）',
    '仮入会（准会員）',
    '准会員',
    '申請（准会員から正会員）',
    '正会員（准会員から移行）',
    '名誉会員',
    '審査中（准会員）',
    '審査中（准会員から正会員）',
    '寄贈',
    '購読者',
    '申込（学生会員）',
    '仮入会（学生会員）',
    '学生会員',
    '審査中（学生会員）',
  ];

export default MemberTypeItemNames;
